class CurrencySelector extends HTMLElement {

    #options;
    #form;
    #optionList;
    #curCurrency;
    #toggleButton;
    #prefIso = ['GB', 'US', 'AU'];

    constructor() {
      super();
      this.#curCurrency = this.getAttribute('data-current') || this.#prefIso[0];
      this.#options = this.getOptions(JSON.parse(this.getAttribute('data-countries')));
      this.#form = this.querySelector('form');
      this.#toggleButton = this.makeToggleButton();
      this.#optionList = this.makeOptionButtons();
      this.appendChild(this.#toggleButton);
      this.#form.appendChild(this.#optionList);
    }

    getOptions(options) {
      // We pre-select options with our preferred country ISO codes
      const preSelections = options.filter(val => this.#prefIso.includes(val.countryIsoCode));
      const prefCurrencies = preSelections.map(val => val.currencyIsoCode);
      return options
        .filter((val, idx, arr) => {
            return (
              idx === arr.findIndex(option => val.currencyIsoCode === option.currencyIsoCode)
              // Exclude any countries with currencies matching our pre-selection, so we don't get multiple
              // territories with the same symbol
              && !prefCurrencies.includes(val.currencyIsoCode)
            );
        })
        .concat(preSelections)
        .sort((a, b) => a.currencyIsoCode.localeCompare(b.currencyIsoCode));
    }


    makeToggleButton() {
        const button = document.createElement('button');
        const curCurrency = this.#options.find(option => option.countryIsoCode === this.#curCurrency);
        button.setAttribute('type', 'button');
        button.setAttribute('class', 'currency-selector__toggle');
        button.innerText = `${curCurrency.currencyIsoCode} ${curCurrency.symbol}`;
        button.addEventListener('click', ev => this.toggleMenu());
        return button;
    }

    toggleMenu() {
        this.#optionList.classList.toggle('currency-selector__options--open');
    }

    makeOptionButtons() {
      const ul = document.createElement('ul');
      ul.setAttribute('class', 'currency-selector__options');
      this.#options.forEach(option => {
        const li = document.createElement('li');
        li.setAttribute('class', 'currency-selector__option')

        const radio = document.createElement('input');
        radio.setAttribute('class', 'currency-selector__radio');
        radio.setAttribute('type', 'radio');
        radio.setAttribute('id', `countryCode-${option.countryIsoCode}`);
        radio.setAttribute('name', 'country_code');
        radio.setAttribute('value', option.countryIsoCode);
        if (option.countryIsoCode === this.#curCurrency) {
            radio.setAttribute('checked', true);
        }
        radio.addEventListener('change', ev => this.chooseCurrency(ev.target.value));

        const label = document.createElement('label');
        label.setAttribute('class', 'currency-selector__label');
        label.setAttribute('for', `countryCode-${option.countryIsoCode}`);
        label.textContent = `${option.currencyIsoCode} ${option.symbol}`;

        li.appendChild(radio);
        li.appendChild(label);
        ul.appendChild(li);
      });
      return ul;
    };

    chooseCurrency(countryIsoCode) {
        this.#curCurrency = countryIsoCode;
        this.#form.submit();
    }
  }

  customElements.define('currency-selector', CurrencySelector);